import { Component, Input, ViewEncapsulation, Output, EventEmitter, OnChanges, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UtilsService } from '@app/core/services';
import { TranslateModule } from '@ngx-translate/core';
import { TcCurrencyPipe } from '@app/shared/pipes';
import { MatSliderModule } from '@angular/material/slider';
import { TooltipDirective } from '@app/shared/directives/tooltip.directive';

@Component({
    selector: 'tc-balance-under-input',
    imports: [
        MatSliderModule,
        TranslateModule,
        TcCurrencyPipe,
        TooltipDirective
    ],
    templateUrl: './balance-under-input.component.html',
    styleUrls: ['./balance-under-input.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BalanceUnderInputComponent implements OnChanges {


    @Output() selectedValueEmit = new EventEmitter<string>();
    @Input() balance: number;
    @Input() currency: string;
    @Input() precision: number;
    @Input() minValue: number;
    @Input() maxValue: number;
    @Input() value = "0";
    @Input() balanceText;
    @Input() crypto: boolean = false;

    percant = 0;

    constructor(
        private utilService: UtilsService
    ) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            !changes.value ||
            !changes.value.currentValue ||
            changes.value.currentValue.length < 1
        ) {
            this.value = "0";
        }
        if (changes.value) {
            let amount: any = this.value;
            if (typeof this.value !== 'number') {
                amount = this.utilService.removeAmountSeparator(this.value);
            }
            this.calcPercenOfValue(amount);
        }
    }

    public rangeChanged(newValue: any) {
        this.value = newValue;
        this.selectedValueEmit.emit(((newValue * this.balance) / 100).toFixed(this.precision));
    }


    private calcPercenOfValue(value): void {
        this.percant = (value / this.balance) * 100;
    }



}
